import DuckEntity from './DuckEntity';
import { entity as contacts } from './contacts';
import { arrayOf } from 'normalizr';
import queryString from "query-string";
import {useEffect, useState} from "react";
import { actionize } from '../utils';

const baseEntity = new DuckEntity('contracts', {
  schemaDefinition: {
    contact: contacts.schema
  }
});

baseEntity.actions.fetchPaymentPlanPreview = (contract_id, payment_plan_id) => {
  const queryParams = queryString.stringify({payment_plan_id});

  return fetch(`/api/contracts/${contract_id}/payment_plan_preview?` + queryParams, {
    credentials: 'include',
  }).then(
    (response) => response.json()
  );
};

baseEntity.hooks.usePaymentPlanPreview = (contract, payment_plan_id) => {
  const [preview, setPreview] = useState({loaded: false});

  useEffect(() => {
    baseEntity.actions.fetchPaymentPlanPreview(contract.id, payment_plan_id)
      .then((data) => {
        setPreview({
          data,
          loaded: true
        });
      })
      .catch((error) => {
        setPreview({
          data: null,
          error
        });
      })
    ;
    return () => setPreview({loaded: false}); //
  }, [contract.id, contract.updated_at, payment_plan_id]);

  return preview;
};

let types = {
  SELECT_PAYER_SPLIT: null
};
types = actionize(types, (action) => `schooladmin/contracts/${action}`);

const currentContractReducer = (state={}, action) => {
  switch(action.type){
    case types.SELECT_PAYER_SPLIT:
      return {
        ...state,
        selectedBillingPayerId: action.selectedBillingPayerId
      };
    default:
      return state;
  }
};

baseEntity.actions.selectBillingPayer = (selectedBillingPayerId) => (
  {
    type: types.SELECT_PAYER_SPLIT,
    selectedBillingPayerId
  }
);

baseEntity.hooks.useBillingPayerSplit = (contract, billingPayerId) => {
  if (!contract || !contract.contract_payer_splits || !contract.contract_payer_splits.some(x => x)) {
    return null;
  }

  return contract.contract_payer_splits.find(split => split.billing_payer_id === billingPayerId) ||
    contract.contract_payer_splits[0];
};

const initialState = {
  ...baseEntity.initialState,
  currentContract: {}
}

const reducer = (state = initialState, action) => ({
  ...baseEntity.reducer(state, action),
  currentContract: currentContractReducer(state.currentContract, action)
});

export default reducer;

export const entity = {...baseEntity, reducer};
